import(/* webpackMode: "eager", webpackExports: ["DictPageClient"] */ "/app/app/[locale]/dict/dict-page-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
